import React from "react";
import Content from "../../Content";

import * as svg from "../../SvgAssets"

const useCaseList = [
  {
    icon: svg.Street,
    label: 'Street Furniture'
  },
  {
    icon: svg.School,
    label: 'School'
  },
  {
    icon: svg.Mrt,
    label: 'Public Transport'
  },
  {
    icon: svg.ShoppingMall,
    label: 'Shopping Center'
  },
  {
    icon: svg.Led,
    label: 'LED Billboard'
  },
  {
    icon: svg.Office,
    label: 'Office'
  },
  {
    icon: svg.Supermarket,
    label: 'Supermarket'
  },
  {
    icon: svg.Restaurant,
    label: 'Restaurant'
  },
  {
    icon: svg.Airport,
    label: 'Airport'
  },
  {
    icon: svg.Wedding,
    label: 'Wedding'
  },
  {
    icon: svg.Concerts,
    label: 'Concerts'
  },
  {
    icon: svg.Banks,
    label: 'Bank'
  },
];

const renderUseCaseList = useCaseList.map((item, id) => (
  <div className="col-sm-6" key={id}>
    <div className="thumbnail">
      <img src={item.icon} alt={item.label}/><span>{item.label}</span>
    </div>
  </div>
));

export default ({ className, ...props }) => (
  <Content className={className} {...props}>
    <div className="row">
      <div className="col-md-6">
        <h2>
          Use Case
          <hr/>
        </h2>
      </div>
      <div className="col-md-6">
        <p>Lumio is made to be used in all kinds of scenarios.
          It works well for both indoor and outdoor use.</p>
        <div className="list-use-case row">
          {renderUseCaseList}
        </div>
      </div>
    </div>
  </Content>
);


// WEBPACK FOOTER //
// ./src/components/Page/Home/UseCase.js